import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutMainComponent } from './layouts/main/layout.main.component';
import { LoginComponent } from './components/login/login.component';
import { AccountComponent } from './components/account/account.component';
import { JobComponent } from './components/job/job.component';
import { JobAddComponent } from './components/job/add.component';
import { CandidateDetailComponent } from './components/candidate/candidate-detail.component';

import { AuthGuardService as AuthGuard } from './services/auth-guard.service';
import { CanDeactivateGuard } from './services/can-deactivate-guard.service';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: 'account', pathMatch: 'full' },
  { path: '',
    component: LayoutMainComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'account', component: AccountComponent, canDeactivate: [CanDeactivateGuard] },
      { path: 'jobs', component: JobComponent },
      { path: 'jobs/:jobOrderId', component: JobComponent },
      { path: 'job/add', component: JobAddComponent },
      { path: 'candidate/:jobAppId/:candidateId', component: CandidateDetailComponent }
    ] },
  { path: '**', redirectTo: 'account' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class RoutingModule {}



// WEBPACK FOOTER //
// ./src/app/routing.module.ts